import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/www/src/components/mdx/index.tsx";
import { graphql } from 'gatsby';
import { ComponentHeader } from 'components/thumbprint-components';
export const pageQuery = graphql`
    {
        # Get links to by path to display in the navbar.
        platformNav: allSitePage(filter: { path: { glob: "/components/carousel/*/" } }) {
            edges {
                node {
                    ...PlatformNavFragment
                }
            }
        }
    }
`;
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  pageQuery,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <ComponentHeader data={props.data} mdxType="ComponentHeader" />
    <h3>{`Usage`}</h3>
    <p>{`ThumbprintCarousel is a RecyclerView which imposes standard Thumbprint styles for carousels; in particular:`}</p>
    <ul>
      <li parentName="ul">{`sets the orientation to horizontal`}</li>
      <li parentName="ul">{`uses a `}<a parentName="li" {...{
          "href": "https://developer.android.com/reference/kotlin/androidx/recyclerview/widget/LinearLayoutManager"
        }}>{`LinearLayoutManager`}</a></li>
      <li parentName="ul">{`disables clipping for children within its padding (android:clipToPadding)`}</li>
      <li parentName="ul">{`adds a 8dp space between items`}</li>
    </ul>
    <p>{`Note that ThumbprintCarousel automatically applies R.style.Thumbprint_Carousel; it does not need to be added as a style in XML.`}</p>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      